import React, { useEffect, useMemo, useState } from 'react'
import PipeCard from './PipeCard'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import language from '../../variables/language';
import { useDroppable } from '@dnd-kit/core';

export default function PipeColumn(props) {

   const navigate = useNavigate();
   const [data,setData] =  useState([]);
   const [satatus, setSatatus] = useState('wait');
   const { setNodeRef, isOver } = useDroppable({ id: props.id });

   const fetchUrl = useMemo(() => {
      const convParam = props.conversationId ? '&conversation=' + props.conversationId : '';
      return props.url + '?stage=' + props.id + convParam;
   }, [props.url, props.id, props.conversationId]);

   useEffect(() => {
      setSatatus('wait');
      axios.get(fetchUrl, { withCredentials: true })
      .then(response => {
        setData(response.data);
        setSatatus('none');
      })
      .catch(err => {
        setSatatus('error');
        console.log(err);
      });
   },[fetchUrl, props.refresh])

   const visibleData = useMemo(() => {
      if(!Array.isArray(data)) {
         return [];
      }
      if(!props.nameFilter) {
         return data;
      }
      const needle = props.nameFilter.toLowerCase();
      return data.filter(item => `${item.firstName||''} ${item.lastName||''}`.toLowerCase().includes(needle));
   }, [data, props.nameFilter]);

  return (
    <div className='pipe-column'>
      <div style={{borderBottom:`1px solid ${props.color}`,boxShadow:` 0 2px 7px ${props.color}`}} className='pipe-column-header'>
        {props.title} 
        
      </div>
      <div ref={setNodeRef} className={'pipe-cards-container' + (isOver ? ' pipe-cards-container-over' : '')}>
         {satatus === 'wait' && data.length === 0 ? (
               <div className='pipe-loader'></div>
            ) : satatus === 'error' ? (
               <div className='pipe-column-message pipe-column-message-error'>{language[language.lang]['error']}</div>
            ) : visibleData.length > 0 ? (
               visibleData.map(item => (
                  <PipeCard  key={item.id} stateHundler={props.stateHundler}
                     onRefresh={props.onRefresh}
                     stages={props.stages}
                     stageId={props.id}
                     pending={props.pendingCardId === item.id}
                     id={item.id}
                     client={item}
                     url={props.url}
                     color={props.color}
                     title={item.firstName+" "+ item.lastName}
                     price={item.price}
                     probability={item.probability}
                     category={item.category}
                     source={item.source}
                     dAdd={item.dAdd}
                     uMod={item.uMod}
                     product={(item.product && typeof item.product === 'object')? item.product.name :"None"}
                     ></PipeCard>
               ))
            ) : (
               <div className='pipe-column-message'>{language[language.lang]['Empty list']}</div>
         )}
      </div>

    </div>
  )
}
